// extracted by mini-css-extract-plugin
export var black = "_4f-6";
export var brand = "_4f-1";
export var ddefault = "_4f-0";
export var error = "_4f-3";
export var gray = "_4f-2";
export var highContrast = "_4f-8";
export var outline = "_4f-7";
export var success = "_4f-5";
export var warning = "_4f-4";